// vue.config.js
module.exports = {
        
    publicPath: '/',
    //publicPath: process.env.NODE_ENV === 'production' ? '/eoro/' : '/',

}  